// Tasks now reuses the full Maintenance "Jobs" framework — same status
// workflow, parts list, supplier assignment, prepay handling. The page
// rename + reroute (2026-05-28) per operator decision A1a/3b/4a.
import Maintenance from "./Maintenance";

export default function Tasks() {
  return (
    <Maintenance
      restrictTo="jobs"
      pageTitle="Tasks"
      buttonLabel="New task"
      dialogTitle="New task"
      saveLabel="Create task"
      addButtonTestid="add-task-btn"
      deleteLabel="Delete task"
    />
  );
}
